import React, { useState, useEffect } from "react";
import {
  Switch,
  Input,
  Radio,
  Button,
  notification,
  Modal as ModalAntd,
  Table,
  BackTop
} from "antd";
import {
  EditOutlined,
  StopOutlined,
  DeleteOutlined,
  CheckOutlined,
  PlusOutlined
} from "@ant-design/icons";

import { Popover } from "antd";
import Modal from "../../../Modal";
import EditWeekForm from "../EditWeekForm";
import AddWeekForm from "../AddWeekForm";
import { activateWeekApi, deleteWeekApi, getWeekExportApi } from "../../../../api/week";
import { getAccessToken } from "../../../../api/auth";
import { getCoursesByWeekApi } from "../../../../api/course";
import { checkAction, isAdmin } from "../../../../utils/checkUserPermission";
import { getRoleByIdApi } from "../../../../api/role";
import { getPermissionsActiveApi } from "../../../../api/permission";
import jwtDecode from "jwt-decode";

import "./ListWeeks.scss";

const { confirm } = ModalAntd;
const { Search } = Input;

export default function ListWeeks(props) {
  const {
    weeksActive,
    weeksInactive,
    setReloadWeeks,
  } = props;
  const [permissionsActive, setPermissionsActive] = useState([]);
  const [roleById, setRoleById] = useState([]);
  const [viewWeeksActives, setViewWeeksActives] = useState(true);
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState(null);

  const [filterText, setFilterText] = useState("");
  const [weeksActiveFilter, setWeeksActiveFilter] = useState(
    []
  );
  const [ weeksInactiveFilter, setWeeksInactiveFilter ] = useState([]);

  const accessToken = getAccessToken();
  const userToken = jwtDecode(accessToken); //para obtener los datos del user logueado

  useEffect(() => {
    getPermissionsActiveApi(accessToken, true).then(response => {
      setPermissionsActive(response.permissions);
    });
  }, []);

  useEffect(() => {
    getRoleByIdApi(accessToken, userToken.role).then(response => {
      setRoleById(response.role);
    });
  }, []);

  useEffect(() => {
    const listActive = [];
    if (weeksActive) {
      weeksActive.forEach((element) => {
          if (
            element.description
              .toUpperCase()
              .includes(filterText.toUpperCase()) ||
            element.week_code.toString()
              .toUpperCase()
              .includes(filterText.toUpperCase()) ||
            filterText === ""
          ) {
            listActive.push(element);
          }
      });
    }
    setWeeksActiveFilter(listActive);
  }, [filterText, weeksActive]);

  useEffect(() => {
    const listInactive = [];
    if (weeksInactive) {
      weeksInactive.forEach((element) => {
          if (
            element.description
              .toUpperCase()
              .indexOf(filterText.toUpperCase()) !== -1 ||
            filterText === ""
          ) {
            listInactive.push(element);
          }
      });
    }
    setWeeksInactiveFilter(listInactive);
  }, [filterText, weeksInactive]);

  const addWeekModal = () => {
    setIsVisibleModal(true);
    setModalTitle("Crear Semana");
    setModalContent(
      <AddWeekForm
        setIsVisibleModal={setIsVisibleModal}
        setReloadWeeks={setReloadWeeks}
      />
    );
  };

  return (
    <div className="list-weeks">
      <div className="list-weeks__header">
        {checkAction(permissionsActive, userToken.role, "weeks", "all") ||
        checkAction(permissionsActive, userToken.role, "weeks", "enable") || isAdmin(roleById) ? (
          <>
            <div className="list-weeks__header-switch">
              <Switch
                defaultChecked
                onChange={() =>
                  setViewWeeksActives(!viewWeeksActives)
                }
              />
              <span>
                {viewWeeksActives
                  ? "Activos"
                  : "Inactivos"}
              </span>
            </div>
          </>
          ) : (
            <>
            </>
        )}

        {checkAction(permissionsActive, userToken.role, "weeks", "all") ||
        checkAction(permissionsActive, userToken.role, "weeks", "add") || isAdmin(roleById) ? (
          <>
            <Button type="primary" icon={<PlusOutlined/>} onClick={addWeekModal}>
              Nuevo
            </Button>
          </>
        ) : (
          <>
          </>
        )}
      </div>

      {checkAction(permissionsActive, userToken.role, "weeks", "all") ||
      checkAction(permissionsActive, userToken.role, "weeks", "view") || isAdmin(roleById) ? (
        <>
          <div className="list-weeks__search">
            <Search
              className="Buscar"
              allowClear
              placeholder=""
              onChange={(e) => setFilterText(e.target.value)}
              enterButton
            />
            <h2>

            </h2>
            <h3>
              <strong>Info:</strong> ejemplos de semana ''
            </h3>
          </div>
        </>
      ) : (
        <>
        </>
      )}

      {viewWeeksActives ? (
        <>
          {checkAction(permissionsActive, userToken.role, "weeks", "all") ||
          checkAction(permissionsActive, userToken.role, "weeks", "view") || isAdmin(roleById) ? (
            <>
              <WeeksActive
                weeksActive={weeksActiveFilter}
                setIsVisibleModal={setIsVisibleModal}
                setModalTitle={setModalTitle}
                setModalContent={setModalContent}
                setReloadWeeks={setReloadWeeks}
                accessToken={accessToken}
                userToken={userToken}
                permissionsActive={permissionsActive}
                roleById={roleById}
              />
            </>
          ) : (
            <>
            </>
          )}
        </>
      ) : (
        <>
          {checkAction(permissionsActive, userToken.role, "weeks", "all") ||
          checkAction(permissionsActive, userToken.role, "weeks", "view") || isAdmin(roleById) ? (
            <>
              <WeeksInactive
                weeksInactive={weeksInactiveFilter}
                setIsVisibleModal={setIsVisibleModal}
                setReloadWeeks={setReloadWeeks}
                setModalTitle={setModalTitle}
                setModalContent={setModalContent}
                accessToken={accessToken}
                userToken={userToken}
                permissionsActive={permissionsActive}
                roleById={roleById}
              />
            </>
          ) : (
            <>
            </>
          )}
        </>
      )}

      <Modal
        title={modalTitle}
        isVisible={isVisibleModal}
        setIsVisible={setIsVisibleModal}
        width={800}
      >
        {modalContent}
      </Modal>

      <BackTop/>
    </div>
  );
}

function WeeksActive(props) {
  const {
    weeksActive,
    setIsVisibleModal,
    setModalTitle,
    setModalContent,
    setReloadWeeks,
    accessToken,
    userToken,
    permissionsActive,
    roleById
  } = props;

  const editWeek = (week) => {
    setIsVisibleModal(true);
    setModalTitle(
      `Editar ${week.description ? week.description : "sin descripcion"}`
    );
    setModalContent(
      <EditWeekForm
        week={week}
        setIsVisibleModal={setIsVisibleModal}
        setReloadWeeks={setReloadWeeks}
      />
    );
  };

  const desactivateWeek = (week) => {
    const accessToken = getAccessToken();

    activateWeekApi(accessToken, week._id, false)
      .then((response) => {
        notification["success"]({
          message: response.message,
        });
        setReloadWeeks(true);
      })
      .catch((err) => {
        notification["error"]({
          message: err,
        });
      });
  };

  const showDeleteConfirm = async (week) => {
    let response = await getCoursesByWeekApi(accessToken, week._id);
    if(response.courses.length > 0){
      confirm({
        title: "Eliminando -> Semana",
        content:`No se puede eliminar '${week.description? week.description : "sin descripcion"}' porque existen cursos asociados, ¿Deseas desactivarlo?`,
        okText: "Desactivar",
        okMethod: "danger",
        cancelText: "Cancelar",
        onOk() {
          desactivateWeek(week);
        },
      });
    } else {
      confirm({
        title: "Eliminando -> Semana",
        content: `¿Estás seguro que quieres eliminar a ${week.description? week.description : "sin descripción"}?`,
        okText: "Eliminar",
        okMethod: "danger",
        cancelText: "Cancelar",
        onOk() {
          deleteWeekApi(accessToken, week._id)
          .then((response) => {
            if (response.code === 200) {
              notification["success"]({
                message: response.message,
              });
              setReloadWeeks(true);
            } else if (response.code === 404 || response.code === 500) {
              notification["error"]({
                message: response.message,
              });
            } else if (
              response === "ERR_CONNECTION_REFUSED" ||
              response === "Failed to fetch" ||
              response === undefined
            ) {
              notification["error"]({
                message: "Servidor caido",
              });
            } else {
              notification["error"]({
                message: "Error del servidor",
              });
            }
          })
          .catch((err) => {
            notification["error"]({
              message: err,
            });
          });
        },
      });
    }
  };

  const edit_week= (
    <div>
      {" "}
      <p>Editar Semana</p>{" "}
    </div>
  );

  const desactivate_week = (
    <div>
      {" "}
      <p>Pasar a Semana inactivos</p>{" "}
    </div>
  );

  const delete_week = (
    <div>
      {" "}
      <p>Eliminar Semana</p>{" "}
    </div>
  );

  const columns = [
    {
      title: "Codigo",
      dataIndex: "week_code",
    },
    {
      title: "Descripcion",
      dataIndex: "description",
    },
    {
      title: "Acción",
      key: "action",
      render: (text, week) => (
        <div>
          {checkAction(permissionsActive, userToken.role, "weeks", "all") ||
          checkAction(permissionsActive, userToken.role, "weeks", "edit") || isAdmin(roleById) ? (
            <>
              <Popover content={edit_week}>
                <Button
                  className="button-edit"
                  onClick={() => editWeek(week)}
                >
                  <EditOutlined />
                </Button>
              </Popover>
            </>
          ) : (
            <>
            </>
          )}

          {checkAction(permissionsActive, userToken.role, "days", "all") ||
          checkAction(permissionsActive, userToken.role, "days", "enable") || isAdmin(roleById) ? (
            <>
              <Popover content={desactivate_week}>
                <Button
                  className="button-week"
                  type="primary"
                  onClick={() => desactivateWeek(week)}
                >
                  <StopOutlined />
                </Button>
              </Popover>
            </>
          ) : (
            <>
            </>
          )}

          {checkAction(permissionsActive, userToken.role, "weeks", "all") ||
          checkAction(permissionsActive, userToken.role, "weeks", "delete") || isAdmin(roleById) ? (
            <>
              <Popover content={delete_week}>
                <Button
                  className="button-day"
                  type="danger"
                  onClick={() => showDeleteConfirm(week)}
                >
                  <DeleteOutlined />
                </Button>
              </Popover>
            </>
          ) : (
            <>
            </>
          )}
        </div>
      ),
    },
  ];

  return (
    <Table
      footer={()=>{return weeksActive.length > 0? `Total de registros: ${weeksActive.length}`: false}}
      pagination={{
        pageSize: 50,
        showSizeChanger: false,
      }}
      dataSource={weeksActive}
      columns={columns}
      rowKey="_id"
    />
  );
}

function WeeksInactive(props) {
  const { weeksInactive,
          setReloadWeeks,
          accessToken,
          userToken,
          permissionsActive,
          roleById
        } = props;

  const activateWeek = (week) => {
    const accessToken = getAccessToken();

    activateWeekApi(accessToken, week._id, true)
      .then((response) => {
        notification["success"]({
          message: response.message,
        });
        setReloadWeeks(true);
      })
      .catch((err) => {
        notification["error"]({
          message: err,
        });
      });
  };

  const showDeleteConfirm = async (week) => {
    let response = await getCoursesByWeekApi(accessToken, week._id);
    if(response.courses.length > 0){
      ModalAntd.info({
        title: "Eliminando -> Semana",
        content:`No se puede eliminar '${week.description? week.description : "sin descripción"}' porque existen cursos asociados`,
       onOk(){}
      });
    } else {
      confirm({
        title: "Eliminando -> Semana",
        content: `¿Estás seguro que quieres eliminar a ${week.description? week.description : "sin descripción"}?`,
        okText: "Eliminar",
        okMethod: "danger",
        cancelText: "Cancelar",
        onOk() {
          deleteWeekApi(accessToken, week._id)
            .then((response) => {
              if (response.code === 200) {
                notification["success"]({
                  message: response.message,
                });
                setReloadWeeks(true);
              } else if (response.code === 404 || response.code === 500) {
                notification["error"]({
                  message: response.message,
                });
              } else if (
                response === "ERR_CONNECTION_REFUSED" ||
                response === "Failed to fetch" ||
                response === undefined
              ) {
                notification["error"]({
                  message: "Servidor caido",
                });
              } else {
                notification["error"]({
                  message: "Error del servidor",
                });
              }
            })
            .catch((err) => {
              notification["error"]({
                message: err,
              });
            });
        },
      });
    }
  };

  const activate_week = (
    <div>
      {" "}
      <p>Pasar a Semana activos</p>{" "}
    </div>
  );

  const delete_week = (
    <div>
      {" "}
      <p>Eliminar Semana</p>
    </div>
  );

  const columns = [
    {
      title: "Codigo",
      dataIndex: "week_code",
    },
    {
      title: "Descripcion",
      dataIndex: "description",
    },
    {
      title: "Acción",
      key: "action",
      render: (text, week) => (
        <div>
          {checkAction(permissionsActive, userToken.role, "weeks", "all") ||
          checkAction(permissionsActive, userToken.role, "weeks", "edit") || isAdmin(roleById) ? (
            <>
              <Popover content={activate_week}>
                <Button
                  className="button-activate"
                  onClick={() => activateWeek(week)}
                >
                  <CheckOutlined />
                </Button>
              </Popover>
            </>
          ) : (
            <>
            </>
          )}

          {checkAction(permissionsActive, userToken.role, "weeks", "all") ||
          checkAction(permissionsActive, userToken.role, "weeks", "delete") || isAdmin(roleById) ? (
            <>
              <Popover content={delete_week}>
                <Button
                  className="button-week"
                  type="danger"
                  onClick={() => showDeleteConfirm(week)}
                >
                  <DeleteOutlined />
                </Button>
              </Popover>
            </>
          ) : (
            <>
            </>
          )}
        </div>
      ),
    },
  ];

  return (
    <Table
      footer={()=>{return weeksInactive.length > 0? `Total de registros: ${weeksInactive.length}`: false}}
      pagination={{
        pageSize: 50,
        showSizeChanger: false,
      }}
      dataSource={weeksInactive}
      columns={columns}
      rowKey="_id"
    />
  );
}
